import styled from "@emotion/styled";

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
